
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class OnClickOutside extends Vue {
  @Prop() private do: any;
  @Prop() private payload: any;

  public mounted() {
    const listener = (e: any) => {
      if (e.target !== this.$el && !this.$el.parentNode!.contains(e.target) && !this.$el.contains(e.target)) {
        this.do(this.payload);
      }
    };
    document.addEventListener('click', listener);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('click', listener);
    });
  }
  public render() {
    const slots: any = this.$slots;
    return slots.default[0];
  }
}
